<template>
	<div class="plugins-delivery-container">
		<CardSlashed v-if="userStore?.bannersData && !userStore?.bannersData?.has_takeaway_orders" class="card-info-banner">
			<template #left>
				<div class="card-info-banner-title">
					<h2>{{ getString('card_info_title_1_takeaway') }}</h2>
					<p>{{ getString('card_info_description_1_takeaway') }}</p>
					<a target="_blank" href="https://qromo-help.freshdesk.com/support/solutions/articles/202000100942-asporto" class="icon-link">
						{{ getString('card_info_cta_1_takeaway') }}
						<div class="wrapper-icon">
							<img src="https://img.qromo.io/img/icon-arrow-link-banner-geen.svg" alt="console icon">
						</div>
					</a>
				</div>
			</template>
			<template #right>
				<div class="wrapper-img">
					<picture>
						<source type="image/webp" srcset="https://img.qromo.io/img/image-info-banner-asporto.webp">
						<img src="https://img.qromo.io/img/image-info-banner-asporto.png" alt="product image">
					</picture>
				</div>
			</template>
		</CardSlashed>
		<TakeawayStatusCard @save-status="clickSaveStatus" />
		<TakeawaySettingsCard @save-settings="clickSaveSettings"/>
	</div>
</template>

<script>
import TakeawayStatusCard from "@/console-new/components/plugins/TakeawayStatusCard.vue";
import TakeawaySettingsCard from "@/console-new/components/plugins/TakeawaySettingsCard.vue";

import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore}
	},
	name: "PluginsTakeaway",
	components: {CardSlashed, TakeawayStatusCard, TakeawaySettingsCard},
	data() {
		return {

		}
	},
	created() {
		if (!this.userStore.bannersData?.has_takeaway_orders) {
			this.userStore.fetchBannersData('has_takeaway_orders');
		}
	},
	methods: {
		clickSaveStatus() {
			this.userStore.updateBusiness({takeaway: this.userStore.currBusiness.takeaway ? 1 : 0}, (success, details)=>{
				this.showNotification(success ? 'takeaway-status-updated' : 'generic-fail');
			});
		},
		clickSaveSettings() {
			this.userStore.updateTakeawayOtherPayments((success, details) => {
				if(success) {
					let updateData = {
						takeaway_costs: this.userStore.currBusiness.takeaway_costs,
						takeaway_min_order: this.userStore.currBusiness.takeaway_min_order,
						takeaway_future_days: this.userStore.currBusiness.takeaway_future_days
					}
					this.userStore.updateBusiness(updateData, success=>{
						this.showNotification(success ? "generic-success" : "generic-fail");
					})
				} else {
					this.showNotification(details === "not_subscribed" ? "sms-cash-payments-fail" : "generic-fail");
				}
			});
		},
	},
	watch: {
		'userStore.currBusinessId'(newVal, oldVal) {
			if (!!newVal && newVal !== oldVal) {
				this.userStore.fetchBannersData('has_takeaway_orders');
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.plugins-delivery-container {

	max-width: 1400px;
	margin: 0 auto;
	:deep(.card-container .card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}

			.list-item:last-child::after {
				display: none;
			}
		}
	}
	.card-info-banner {
		margin-bottom: 40px;
		.card-info-banner-title {
			width: 100%;
			height: fit-content;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-direction: column;
			color: var(--color-txt-white);
			max-width: 400px;
			text-align: left;
			.align-text {
				display:flex;
				flex-direction: column;
			}
			&.divider {
				padding-bottom: 20px;
				border-bottom: 1px solid rgba(255, 255, 255, 0.5);
				width: 100%;
				margin-bottom: 20px;
			}
			h2 {
				font-size: 22px;
				display: inline-block;
				color: var(--color-txt-white);
				@media (max-width: 550px) {
					font-size: 20px;
					line-height: normal;
				}
			}
			p {
				color: var(--color-txt-white);
				margin-top: 10px;
				&.br {
					margin-top: 15px!important;
				}
			}
			.card-info-banner-button {
				margin-top: 20px;
			}
		}
		&:deep(.slashed-card-container) {
			padding: 15px 20px;
			background: linear-gradient(204deg, #FDC700 10%, rgb(47, 36, 209) 90%);
			height: 100%;
			gap: 40px;
			position: relative;
			.slashed-left {
				width: calc(65% - 20px);
				justify-content: flex-start;
				padding: 0;
				overflow: unset;
				border-radius: 0;
				flex-direction: column;
				z-index: 2;

				.card-info-banner-title {
					width: 100%;
					max-width: unset;
				}

				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
					min-height: unset;
					.card-info-banner-title {
						width: 100%;
						max-width: unset;
						padding: 0;
					}
				}
			}
			.slashed-right {
				z-index: 2;
				width: calc(35% - 20px);
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
				}
			}
			@media (max-width: 550px) {
				flex-direction: column-reverse;
				gap: 0;
			}
		}
		.wrapper-img {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			picture {
				img {
					width: 100%;
					height: 100%;
					max-height: 250px;
					object-fit: contain;
					@media (max-width: 550px) {
						max-height: 200px;
					}
				}
			}
		}
		.icon-link {
			min-height: 40px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			gap: 7px;
			margin-top: 8px;
			opacity: .9;
			transition: opacity .2s $transition;
			padding-right: 20px;
			font-size: 14px;
			line-height: 14px;
			font-weight: 400;
			color: var(--color-secondary);
			font-style: italic;
			width: calc(100% - 20px);
			&:after {
				display: none;
			}
			.wrapper-icon {
				margin-top: 2px;
				width: 12px;
				height: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: transform .2s $transition;
				transform: translateX(0);
				img {
					width: 100%;
					height: 100%;
					max-height: 180px;
					object-fit: contain;
				}
			}
			&:hover {
				opacity: 1;
				.wrapper-icon {
					transform: translateX(2px);
				}
			}
		}
	}
}
</style>